import { Direction } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/enums.pb';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { Text, useTooltip } from '@frontend/design-system';

type GroupNotDeliveredStatusProps = {
  failedRecipientNames: string[];
  totalRecipients: number;
  direction: Direction;
  compact?: boolean;
};

export const GroupNotDeliveredStatus = ({
  failedRecipientNames,
  totalRecipients,
  direction,
  compact,
}: GroupNotDeliveredStatusProps) => {
  const { t } = useTranslation('thread-body');
  const { Tooltip, tooltipProps, triggerProps } = useTooltip({
    placement: direction === Direction.DIRECTION_INBOUND ? 'top-end' : 'top-start',
    trigger: 'hover',
  });
  const isSmallMode = useMatchMedia({ maxWidth: breakpoints.xsmall.max });
  const isSmallOrCompact = isSmallMode || compact;

  return (
    <>
      <span
        css={{
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing(0.5),
          minWidth: isSmallOrCompact ? '' : '150px',
          justifyContent: isSmallOrCompact ? 'flex-end' : '',
        }}
        {...triggerProps}
      >
        <Icon name='alert-invert-small' color='error' />
        {!isSmallOrCompact && (
          <Text color='error' size='small'>
            {t('Not delivered to {{failed}} of {{total}}', {
              failed: failedRecipientNames.length,
              total: totalRecipients,
            })}
          </Text>
        )}
      </span>
      <Tooltip {...tooltipProps}>
        <div
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(0.25),
            textAlign: 'left',
          }}
        >
          {isSmallOrCompact ? (
            <span css={{ fontWeight: theme.font.weight.bold }}>
              {t('Not delivered to {{failed}} of {{total}}:', {
                failed: failedRecipientNames.length,
                total: totalRecipients,
              })}
            </span>
          ) : (
            <span css={{ fontWeight: theme.font.weight.bold }}>{t('Not delivered to:')}</span>
          )}
          {failedRecipientNames.map((name, index) => (
            <span key={`${name}-${index}`}>{name}</span>
          ))}
        </div>
      </Tooltip>
    </>
  );
};
